import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ requireDashboard = false }) => {
    // 1. Obtener usuario de la sesión local
    const userStr = localStorage.getItem('user');
    let user = null;

    try {
        user = userStr ? JSON.parse(userStr) : null;
    } catch (e) {
        localStorage.clear();
        return <Navigate to="/login" replace />;
    }

    // 2. Verificación de Autenticación (¿Está logueado?)
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // 3. Verificación de Autorización (¿Tiene permiso para entrar aquí?)
    if (requireDashboard) {
        
        // --- LÓGICA DE ACCESO ROBUSTA ---
        
        // A. Verificación Moderna (Base de Datos de Roles)
        const tienePermisoExplicito = user.permisos && user.permisos.dashboard === true;

        // B. Verificación de Respaldo (Para usuarios antiguos o migración)
        // Si el rol NO es 'cliente', asumimos que es staff y debe entrar.
        const esStaff = user.rol !== 'cliente';

        // C. Super Admin (Backdoor de seguridad para ti)
        const esDuenio = user.email === 'dolce.fleur.2026@gmail.com';

        // Debugging (Para que veas en consola por qué entra o no)
        // console.log(`Usuario: ${user.nombre} | Rol: ${user.rol} | Dashboard: ${tienePermisoExplicito}`);

        // Si cumple CUALQUIERA de las 3, entra.
        if (!tienePermisoExplicito && !esStaff && !esDuenio) {
            // Si intenta entrar pero es un cliente mortal, va a su perfil
            return <Navigate to="/mi-cuenta" replace />;
        }
    }

    // 4. Si pasa, renderiza la ruta hija
    return <Outlet />;
};

export default ProtectedRoute;